export default "__VITE_ASSET__BdStrvWS__"